import { type Store, configureStore } from '@reduxjs/toolkit';

import { type RootActions, type RootState, rootReducer } from '../reducers';

export let store: Store<RootState, RootActions>;

export const createStore = (
  preloadedState: Partial<RootState> = {}
): Store<RootState, RootActions> => {
  store = configureStore({
    reducer: rootReducer,
    // @ts-expect-error Partial root state
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });
  return store;
};
